import React, { useState, useRef, useEffect } from 'react';

const RadioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [volume, setVolume] = useState(1);
  const [location, setLocation] = useState(null);
  const [browserInfo, setBrowserInfo] = useState('');
  const [currentStation, setCurrentStation] = useState('http://redir.atmcdn.pl/sc/o2/Eurozet/live/antyradio.livx');
  const [cookieConsent, setCookieConsent] = useState(false);
  const [geoConsent, setGeoConsent] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const browserDetails = {
      name: navigator.appName,
      version: navigator.appVersion,
      userAgent: navigator.userAgent,
      platform: navigator.platform
    };
    setBrowserInfo(browserDetails);

    if (geoConsent && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
        },
        (error) => {
          console.error('Błąd geolokalizacji:', error);
          setLocation({ latitude: 'Nie dostępna', longitude: 'Nie dostępna' });
        }
      );
    }

    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    if (audioRef.current) {
      audioRef.current.load();
      audioRef.current.play();
    }

    return () => {
      clearInterval(timer);
    };
  }, [geoConsent, currentStation]);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleVolumeChange = (event) => {
    const newVolume = event.target.value;
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };

  const handleStationChange = (event) => {
    const newStation = event.target.value;
    setCurrentStation(newStation);
    setIsPlaying(false);
  };

  const handleCookieConsent = () => {
    setCookieConsent(true);
  };

  const handleGeoConsent = () => {
    setGeoConsent(true);
  };

  return (
    <div className="radio-player">
      <h2>Odtwarzacz Antyradio</h2>
      
      <button onClick={togglePlayPause}>
        {isPlaying ? 'Pauza' : 'Odtwórz'}
      </button>

      <div className="station-selector">
        <label htmlFor="station">Wybierz stację:</label>
        <select id="station" onChange={handleStationChange} value={currentStation}>
          <option value="http://redir.atmcdn.pl/sc/o2/Eurozet/live/antyradio.livx">Antyradio</option>
          <option value="http://streaming.radio.co/s22729ef82/listen">Radio ZET</option>
          <option value="http://stream.rcs.revma.com/ypqjzc5j3duvv">RMF FM</option>
          <option value="http://streaming.radionomy.com/Jazz-Jam">Jazz Jam</option>
        </select>
      </div>

      <div className="volume-control">
        <label htmlFor="volume">Głośność:</label>
        <input
          type="range"
          id="volume"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={handleVolumeChange}
        />
      </div>

      <div className="date-time">
        <p>Data: {currentDateTime.toLocaleDateString()}</p>
        <p>Godzina: {currentDateTime.toLocaleTimeString()}</p>
      </div>

      <div className="location-info">
        <h3>Twoja lokalizacja:</h3>
        {location ? (
          <p>Latitude: {location.latitude}, Longitude: {location.longitude}</p>
        ) : (
          <p>Brak dostępu do lokalizacji</p>
        )}
      </div>

      <div className="browser-info">
        <h3>Informacje o przeglądarce:</h3>
        <p><strong>Nazwa:</strong> {browserInfo.name}</p>
        <p><strong>Wersja:</strong> {browserInfo.version}</p>
        <p><strong>Platforma:</strong> {browserInfo.platform}</p>
        <p><strong>Agent użytkownika:</strong> {browserInfo.userAgent}</p>
      </div>

      <audio ref={audioRef} controls>
        <source src={currentStation} type="audio/mpeg" />
        Twoja przeglądarka nie obsługuje elementu audio.
      </audio>

      {!cookieConsent && (
        <div className="cookie-notification">
          <p>Ta strona używa plików cookie w celu poprawy doświadczeń użytkownika. <a href="/privacy-policy">Polityka prywatności</a>.</p>
          <button onClick={handleCookieConsent}>Akceptuję</button>
        </div>
      )}

      {!geoConsent && (
        <div className="geo-notification">
          <p>Używamy geolokalizacji, aby dostarczyć spersonalizowane doświadczenie. <button onClick={handleGeoConsent}>Zgadzam się</button></p>
        </div>
      )}
    </div>
  );
};

export default RadioPlayer;
